module.exports = "/images/pin-start.png?2d588ac08cf3e22b71d98c1115527779";